import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { X } from 'lucide-react';

class ContactField extends Component {
  handleNameChange = (e) => this.props.onChange('name', e.target.value);
  handleEmailChange = (e) => this.props.onChange('email', e.target.value);
  handlePhoneChange = (e) => this.props.onChange('phone', e.target.value);
  handleRemove = () => this.props.onRemove();

  render() {
    const { contact, t } = this.props;
    const { name, email, phone } = contact;

    return (
      <div className="flex flex-wrap md:flex-row w-full">
        <div className="md:w-40 w-full">
          <fieldset className="md:mr-1">
            <input
              className="form-field block mb-4 w-full"
              value={name}
              placeholder={t('NAME')}
              onChange={this.handleNameChange}
            />
          </fieldset>
        </div>
        <div className="md:w-40 w-full">
          <fieldset className="md:mr-1">
            <input
              type="tel"
              className="form-field block mb-4 w-full"
              value={phone}
              placeholder={t('PHONE')}
              onChange={this.handlePhoneChange}
            />
          </fieldset>
        </div>
        <div className="md:w-48 w-full flex items-center">
          <fieldset className="md:mr-1">
            <input
              type="email"
              className="form-field block mb-4 w-full"
              value={email}
              placeholder={t('EMAIL')}
              onChange={this.handleEmailChange}
            />
          </fieldset>
        </div>
        <div className="w-6 border flex items-center justify-center">
          <button
            className="button secondary-action mb-4"
            onClick={this.handleRemove}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }
}

ContactField.propTypes = {
  contact: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
export default withTranslation()(ContactField);
